import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video-player-dialog',
  templateUrl: './video-player-dialog.component.html',
  styleUrls: ['./video-player-dialog.component.scss']
})
export class VideoPlayerDialogComponent implements OnInit {
  link: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dom: DomSanitizer) { }

  ngOnInit() {
    const tag = document.createElement('script');
    this.link = this.dom.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + this.data.videoUrl);
    tag.src = 'https://www.youtube.com/iframe_api';
    document.body.appendChild(tag);
  }

}
